import styled from 'styled-components';
export const StyledTextElement = styled.div`
  display: block;

  & > * + * {
    margin-top: var(--flow-space, 1rem);
  }
`;
